import React from 'react'
import { StyledFeatureVariable } from '@mc/feature-variables'
import { useTranslation } from '@mc/i18n'
import { PROMO_FEATURE_FLAG, usePromotion } from '@mc/promo-utils'
import { PROMO_I18N_NAMESPACE } from '@mc/promos'

export const PromoMenuItem = ({ label }: { label: React.ReactNode }) => {
  const { t } = useTranslation(PROMO_I18N_NAMESPACE)
  const { isPromotionOn } = usePromotion()

  if (!isPromotionOn) {
    return label
  }

  return (
    <div className='d-flex align-items-center'>
      <span className='flex-1'>{label}</span>
      <span
        className='mc-text-x-small mc-text--uppercase mc-ml-1 mc-bg-primary mc-text--bold mc-corners--1'
        style={{ padding: '2px 6px' }}
      >
        <StyledFeatureVariable
          flagName={PROMO_FEATURE_FLAG}
          variableName='discount_copy'
          defaultCopy={t(
            'common.home.modals.discount.promotionAppliedOnError.cta',
          )}
        />
      </span>
    </div>
  )
}
